<template>
  <div>
    <!-- <v-app-bar flat outlined>
      <v-avatar color="grey" class="mr-2">
        <v-img :src="ip+cliente.profileImage"></v-img>
      </v-avatar>
      <v-toolbar-title class="ml-1">
        <b style="font-size:0.8em;">{{cliente.nome}}</b>
      </v-toolbar-title>
      <v-btn icon>
        <v-icon @click="newWhats(cliente)">mdi-whatsapp</v-icon>
      </v-btn>
    </v-app-bar>-->
    <v-card style="height: 90vh" outlined color="#fafafa">
      <v-card-text>
        <v-container>
          <v-card shaped>
            <v-card-title>
              <v-list style="width: 100%">
                <v-list-item>
                  <v-list-item-avatar
                    color="grey"
                    style="height: 60px; width: 60px"
                    class="userimage"
                  >
                    <v-img :src="ip + clienteState.profileImage"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      clienteState.nome
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <v-icon @click="modalWhats = true">mdi-whatsapp</v-icon>
                    <v-icon @click="modalDial = true">mdi-phone</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </v-list>
            </v-card-title>

            <v-tabs v-model="tabs" fixed-tabs>
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#mobile-tabs-5-1" class="primary--text">
                <v-icon>mdi-account-box</v-icon>
              </v-tab>
              <v-tab href="#mobile-tabs-5-2" class="primary--text">
                <v-icon>mdi-book-open-variant</v-icon>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabs">
              <v-tab-item
                value="mobile-tabs-5-1"
                style="height: 60vh; overflow-y: scroll"
              >
                <v-container v-if="cliente">
                  <!-- <v-text-field
                    v-for="(value, key,index) in clienteTratado"
                    :key="index"
                    :label="key"
                    :value="value"
                    :prepend-icon="getIcon(key)"
                    readonly
                  ></v-text-field>-->
                  <template v-for="(value, key, index) in cliente">
                    <v-text-field
                      v-if="
                        key !== `CamposAdicionais` &&
                        key !== `NumerosAdicionais`
                      "
                      :key="index"
                      dense
                      :label="t(`${key}`)"
                      :value="value"
                      readonly
                    ></v-text-field>
                    <template v-if="key === `CamposAdicionais`">
                      <v-text-field
                        v-for="campo in value"
                        :key="campo.id"
                        dense
                        :label="t(`${campo.nome}`)"
                        :value="campo.valor"
                        readonly
                      ></v-text-field>
                    </template>
                    <template v-if="key === `NumerosAdicionais`">
                      <v-text-field
                        v-for="numero in value"
                        :key="numero.id"
                        dense
                        :label="t(`${numero.nome}`)"
                        :value="numero.numero"
                        readonly
                      ></v-text-field>
                    </template>
                  </template>
                </v-container>
              </v-tab-item>
              <v-tab-item
                value="mobile-tabs-5-2"
                style="height: 60vh; overflow-y: scroll"
              >
                <v-list>
                  <v-list-item
                    v-for="(item, index) in orderBy(atendimentos, 'id', -1)"
                    :key="index"
                    @click="setAtendimento(item)"
                  >
                    <v-list-item-avatar></v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>#{{ item.id }}</v-list-item-title>
                      <v-list-item-subtitle
                        v-html="`${formataData(item.dataIni)}`"
                      ></v-list-item-subtitle>
                      <v-list-item-subtitle
                        v-html="`${t(item.status)}`"
                      ></v-list-item-subtitle>
                      <v-list-item-subtitle
                        v-html="`${t('fila')}: ${item.queue}`"
                      ></v-list-item-subtitle>
                      <v-list-item-subtitle
                        v-show="item.queueTypeID == 4"
                        v-html="`${t('assunto')}: ${item.assunto}`"
                      ></v-list-item-subtitle>
                      <v-list-item-subtitle
                        v-html="`${t('ultimoAgente')}: ${item.ultimoAgente}`"
                      ></v-list-item-subtitle>
                      <v-divider></v-divider>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <!-- <v-btn text color="deep-purple accent-4">Read</v-btn>
        <v-btn text color="deep-purple accent-4">Bookmark</v-btn>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon>mdi-heart</v-icon>
        </v-btn>
        <v-btn icon>
          <v-icon>mdi-share-variant</v-icon>
        </v-btn>-->
      </v-card-actions>
    </v-card>
    <NovoWhats
      :open="modalWhats"
      :item="cliente"
      v-on:update="closeModalWhats($event)"
    />
    <!-- <NovaLigacao
      :open="modalLigacao"
      :item="cliente"
      v-on:update="closeModalLigacao($event)"
    /> -->

    <b-modal
      id="modal-chat"
      title
      size="xl"
      scrollable
      centered
      style="max-height: 60vh; overflow-y: scroll"
    >
      <chat />
      <template v-slot:modal-footer>
        <button hidden></button>
      </template>
    </b-modal>
    <v-dialog v-model="modalDial">
      <Dial v-on:update="modalDial = $event" :numero="cliente.numero" />
    </v-dialog>
  </div>
</template>
   
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import Vue2Filters from "vue2-filters";
import NovoWhats from "./dialogs/NovoWhats";
import NovaLigacao from "./dialogs/NovaLigacao";
import Dial from "./Home";
import moment from "moment";

export default {
  name: "Cliente",
  components: {
    chat: () => import("./ChatH"),
    NovoWhats,
    NovaLigacao,
    Dial,
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      whatsForm: {
        numero: null,
        queue: null,
        instancia: null,
        nome: null,
      },
      modalWhats: false,
      modalLigacao: false,
      modalDial: false,
      tabs: null,
      ip: "http://" + JSON.parse(localStorage.getItem("config")).servidor,
      clienteForm: Object,
      grupos: Array,
      atendimentos: [],
      cliente: null,
    };
  },
  created() {
    this.getClienteByID();
    this.getGrupos();
    this.getAtendimentos();
    // if(this.token) this.$router.push("/main");
  },
  computed: {
    ...mapState("xc", {
      clienteState: (state) => state.cliente,
      atendimento: (state) => state.atendimentoH,
    }),
    ...mapState("auth", {
      user: (state) => state.user,
    }),
    clienteTratado() {
      //eslint-disable-next-line no-unused-vars
      /* eslint-disable  */
      let { idGrupo, profileImage, isBusiness, clienteGrupo, id, ...data } =
        this.cliente;
      /* eslint-enable */

      data = Object.entries(data).reduce(
        (a, [k, v]) => (v ? ((a[k] = v), a) : a),
        {}
      );

      if (data) return data;
      return this.cliente;
    },
  },
  watch: {
    clienteState() {
      this.getClienteByID();
      this.getAtendimentos();
    },
  },

  methods: {
    formataData(dataIni) {
      return moment(dataIni).format("L");
    },
    closeModalWhats(event) {
      if (event === "new") {
        this.modalWhats = false;
        this.selectCliente(null);
        this.$router.push(`/home`);
      }
      this.modalWhats = false;
    },
    closeModalLigacao(event) {
      if (event === "new") {
        this.modalLigacao = false;
      }
      this.modalLigacao = false;
    },
    async getClienteByID() {
      try {
        if (!this.clienteState) return;
        let retorno = await this.getDefault(
          `/api/v2/clientes/${this.clienteState.id}`
        );
        //eslint-disable-next-line no-unused-vars
        /* eslint-disable  */
        let { idGrupo, profileImage, isBusiness, clienteGrupo, id, ...data } =
          retorno;
        /* eslint-enable */

        data = Object.entries(data).reduce(
          (a, [k, v]) => (v ? ((a[k] = v), a) : a),
          {}
        );
        if (data.CamposAdicionais && data.CamposAdicionais.length == 0)
          delete data.CamposAdicionais;
        if (data.NumerosAdicionais && data.NumerosAdicionais.length == 0)
          delete data.NumerosAdicionais;
        this.cliente = data;
      } catch (error) {
        console.error(error);
      }
    },
    getIcon(key) {
      let icon = "mdi-file-document";
      if (key === "numero") icon = "mdi-phone";
      if (key === "isBusiness") icon = "mdi-whatsapp";
      if (key === "email") icon = "mdi-email";
      return icon;
    },
    ...mapActions("xc", [
      "getDefault",
      "updateCliente",
      "selectCliente",
      "selectAtendimentoH",
      "newWhatsApp",
    ]),
    ...mapActions("sip", ["ligar"]),
    async getGrupos() {
      try {
        let grupos = await this.getDefault(
          "/api/v2/clientesGrupos?max=-1&page=1"
        );
        this.grupos = grupos;
      } catch (error) {
        console.error(error);
      }
    },
    async getAtendimentos() {
      let protocolos = await this.getDefault(
        `/api/v2/atendimentos/${this.clienteState.id}`
      );
      let filas = this.user.filas.map((f) => f.fila);
      let atendimentos = protocolos.filter((a) => {
        if (filas.indexOf(a.queue) !== -1) {
          return true;
        }
      });
      this.atendimentos = atendimentos;
    },
    async setAtendimento(item) {
      try {
        item.pesquisa = true;
        await this.selectAtendimentoH(item);
        this.$bvModal.show(`modal-chat`);
      } catch (error) {
        console.error(error);
      }
    },
    async getFilas() {
      try {
        let retorno = await this.getDefault("/api/v3/fila?max=-1&page=1");
        return retorno.dados;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style>
</style>